import { Styles } from 'assets/types';
import analyticsCardStyles from 'assets/stylesheets/defaultStyles/analyticsCard.style';

const referralSourceFormDataCardStyles: Styles = theme => {
  const newAnalyticsCardStyle = analyticsCardStyles(theme) || {};
  return {
    ...newAnalyticsCardStyle,
  };
};

export default referralSourceFormDataCardStyles;
